import { render } from "./activityList.vue?vue&type=template&id=0bdfe3cc&ts=true"
import script from "./activityList.vue?vue&type=script&lang=ts&config=true"
export * from "./activityList.vue?vue&type=script&lang=ts&config=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__